import React from 'react'
import { connect } from 'react-redux'
import { changeServiceFilter } from '../actions/services'

function mapStateToProps(state, props) {
    const { filters, isFetching, counts } = state.services
    const filter = filters[props.filterId]
    const count = filter && counts[filter.searchKey]
    return {
        filter,
        countries: state.countries.countries,
        count,
        isFetching,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        changeFilter: (id, options) => dispatch(changeServiceFilter(id, options)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
